import { useAlias } from '../../aliases/hooks/useAlias';
import { useRandomAliasGenerator } from '../../../hooks/useRandomAliasGenerator';
import { AliasStatus, AliasType } from '../../aliases/types';

export const useGenerateAlias = () => {
    const { createRecord } = useAlias();
    const { generateRandomAlias } = useRandomAliasGenerator();

    const generate = async (count: number = 1) => {
        const promises = [];
        for (let i = 0; i < count; i++) {
            const alias = {
                name: generateRandomAlias(),
                aliasStatus: AliasStatus.ENABLED,
                aliasType: AliasType.USER,
            };
            promises.push(createRecord(alias as any));
        }
        await Promise.all(promises);
    };

    return { generate };
};
